import { EMPTY, Observable } from 'rxjs';
import { delay, expand, reduce } from 'rxjs/operators';
import { CrmPaginated, CrmPagination } from 'common-module/table';

export const loadAllPaginated = <T>(
  operationFactory: (
    pagination: CrmPagination,
    params?: any,
  ) => Observable<CrmPaginated<T>>,
  config?: {
    pageSize?: number;
    params?: any;
  },
): Observable<T[]> => {
  const pageSize = config?.pageSize ?? 100;
  return operationFactory(
    {
      limit: pageSize,
      skip: 0,
    },
    config?.params ?? {},
  ).pipe(
    expand((result: CrmPaginated<T>) => {
      const { limit, skip, total } = result;
      const loadedCount = Math.min(skip + limit, total ?? 0);
      if (loadedCount < (total ?? 0)) {
        return operationFactory(
          { skip: loadedCount, limit: pageSize },
          config?.params ?? {},
        ).pipe(delay(100));
      } else {
        return EMPTY;
      }
    }),
    reduce((acc: any[], value: CrmPaginated<T>) => {
      return acc.concat(value.data);
    }, []),
  );
};
